export default function Mastercard({ className = "" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 395 233"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_693_3"
        maskUnits="userSpaceOnUse"
        x="0"
        y="4"
        width="395"
        height="227">
        <path
          d="M0 18.3575C0 10.5909 6.34821 4.23633 14.1071 4.23633H380.893C388.652 4.23633 395 10.5909 395 18.3575V216.055C395 223.821 388.652 230.176 380.893 230.176H14.1071C6.34821 230.176 0 223.821 0 216.055V18.3575Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_693_3)">
        <path
          d="M234.885 43.7759H143.894V190.636H234.885V43.7759Z"
          fill="#FF5F00"
        />
        <path
          d="M162.938 117.206C162.938 103.085 166.465 88.9638 172.108 76.2548C178.456 63.5457 187.625 52.2487 198.911 43.776C184.804 33.1851 167.875 26.1245 150.241 24.0063C132.608 21.8881 114.974 25.4184 98.7504 33.1851C82.5272 40.9517 69.8308 52.9548 59.9558 67.782C50.7861 82.6093 45.8486 99.5548 45.8486 117.206C45.8486 134.858 50.7861 151.803 59.9558 166.631C69.1254 181.458 82.5272 193.461 98.7504 201.227C114.974 208.994 132.608 211.818 150.241 210.406C167.875 208.288 184.804 201.934 198.911 190.637C187.625 182.164 178.456 170.867 172.108 158.158C165.759 145.449 162.938 131.327 162.938 117.206Z"
          fill="#EB001B"
        />
        <path
          d="M323.759 172.279H325.17V171.573H322.349V172.279H323.759ZM330.108 175.103V171.573H329.402L327.991 174.397L326.581 171.573H325.875V175.103H326.581V172.279L327.286 174.397H327.991L328.697 172.279L330.108 175.103Z"
          fill="#F79E1B"
        />
        <path
          d="M351.974 117.206C351.974 134.858 347.036 151.803 337.866 166.631C328.697 181.458 315.295 193.461 299.072 201.227C282.849 208.994 265.215 211.818 247.581 210.406C229.947 208.288 213.018 201.934 198.911 190.637C210.197 182.164 219.366 170.867 225.715 158.158C232.063 145.449 235.59 131.327 235.59 117.206C235.59 103.085 232.063 88.9638 225.715 76.2548C219.366 63.5457 210.197 52.2487 198.911 43.776C213.018 33.1851 229.947 26.1245 247.581 24.0063C265.215 21.8881 282.849 25.4184 299.072 33.1851C315.295 40.9517 328.697 52.9548 337.866 67.782C347.036 82.6093 351.974 99.5548 351.974 117.206Z"
          fill="#F79E1B"
        />
      </g>
    </svg>
  )
}
